import * as types from "./actionTypes";
import { initialState } from "./initialState";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_USER_ACCOUNTS:
      return action.payload;
    default:
      return state;
  }
};

export default reducer;
